export const formatBatchStatus = value => (value || '').toLowerCase().split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');

export const formatBatchDate = value => {
    if (!value) return '—';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '—' : new Intl.DateTimeFormat('en-GB', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
    }).format(date);
};

export const formatBatchDuration = (startedAt, completedAt) => {
    if (!startedAt) return 'Not started';
    if (!completedAt) return 'In progress';
    const elapsed = new Date(completedAt).getTime() - new Date(startedAt).getTime();
    if (!Number.isFinite(elapsed) || elapsed < 0) return '—';
    const seconds = Math.floor(elapsed / 1000);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    return [hours ? `${hours}h` : '', minutes ? `${minutes}m` : '', `${seconds % 60}s`].filter(Boolean).join(' ');
};

export const batchStatusClass = status => {
    if (status === 'COMPLETED') return 'bg-green-50 text-green-800 dark:bg-green-500/10 dark:text-green-200';
    if (status === 'FAILED') return 'bg-red-50 text-red-800 dark:bg-panda-pink/10 dark:text-panda-pink';
    if (['CANCELLED', 'PARTIALLY_COMPLETED'].includes(status)) return 'bg-amber-50 text-amber-900 dark:bg-amber-400/10 dark:text-amber-200';
    return 'bg-cyan-50 text-cyan-800 dark:bg-panda-cyan/10 dark:text-panda-cyan';
};
